// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"A5-z"};